/**
 * F-0604 WAIT-21a (`docs/concept-waiting-motion.md`): when the person's wait started. A wait's stages
 * count from the press that opened it, not from the moment its pane mounted: on a loaded machine the
 * pane mounted 1.5 to 2 s after the press, and the study came 3.5 to 4 s after it.
 *
 * The last press is stamped by the app's one press tracker (`hooks/pointerPress.ts`, T-0698) in the
 * capture phase, before any handler can start a read: a pointer down, or Enter or Space on the
 * keyboard. A wait that mounts within `PRESS_ORIGIN_MS` of it counts from it; one that mounts with no
 * press that recent (a deep link, a reload, the browser's Back) counts from its own mount.
 */

import { forgetLastPress, lastPressTime } from '../hooks/pointerPress';

/** How long after a press a wait that mounts is still that press's wait. */
export const PRESS_ORIGIN_MS = 5_000;

/** The time a wait mounting `now` counts from: the press that started it, or `now`. */
export function waitOrigin(now: number = Date.now()): number {
  const lastPress = lastPressTime();
  return lastPress !== null && now - lastPress >= 0 && now - lastPress <= PRESS_ORIGIN_MS
    ? lastPress
    : now;
}

/** Tests only: forget the last press. */
export function forgetPress(): void {
  forgetLastPress();
}
